import { Head, useMutation } from 'arcway/lib/client'
import { useState } from 'react'

import { Container } from '#components/container.jsx'
import {
  ImportPreviewForm,
  PublicImportAction,
} from '#components/import/preview.jsx'
import { PublicLayout } from '#components/layouts/public.jsx'

export default function ImportPage() {
  const previewRequest = useMutation('/import/preview', { method: 'POST' })
  const [preview, setPreview] = useState(null)

  async function previewFeed(url) {
    const response = await previewRequest.trigger({ url })
    setPreview(response)
  }

  return (
    <>
      <Head
        description='Import an existing podcast RSS feed and episodes into Mono.'
        title='Import a podcast — mono.fm'
      >
        {process.env.NODE_ENV === 'development' && (
          <link rel='stylesheet' href='/pages/_styles.css?direct' />
        )}
      </Head>
      <PublicLayout>
        <Container className='py-14 sm:py-20'>
          <div className='mx-auto max-w-3xl'>
            <header className='mb-10'>
              <p className='text-sm font-medium text-muted-foreground'>
                Move to Mono
              </p>
              <h1 className='mt-3 text-4xl font-semibold tracking-tight sm:text-5xl'>
                Import your podcast
              </h1>
              <p className='mt-5 text-lg leading-8 text-muted-foreground'>
                Already have a podcast somewhere else? Enter its public RSS feed
                and bring the show and eligible episodes into Mono.
              </p>
            </header>
            <ImportPreviewForm
              action={url => <PublicImportAction url={url} />}
              loading={previewRequest.loading}
              onPreview={previewFeed}
              preview={preview}
            />
          </div>
        </Container>
      </PublicLayout>
    </>
  )
}
